export default __webpack_public_path__ + "static/niche@mob-9ef541c68bb66576ea063458d5f592ad.webp";